<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">
      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">Upload Attendance</h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">Upload Attendance</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->

      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                &nbsp;&nbsp;
                <a
                  :href="`${mediaUrl}samples/user-sample-data.xlsx`"
                  target="_blank"
                >
                  [ Download Sample Excel ]
                </a>

                <input
                  type="file"
                  id="file"
                  name="file"
                  ref="file"
                  accept="application/ms-excel"
                  multiple
                />
                <br />
                <a href="javascript:void" @click="truncatePendingDocuments"
                  >Truncate List</a
                >
                <br /><br />
                <span style="color: red"> {{ message }} </span>
                <span v-if="isLoading"> Uploading...</span>

                <div class="form-footer" v-if="crudAttendance.length == 0">
                  <button
                    class="btn btn-primary btn-block"
                    @click="handleFileUpload"
                  >
                    Upload file
                  </button>
                </div>

                <div class="form-footer" v-else>
                  <button
                    class="btn btn-success btn-block"
                    @click="processFile"
                  >
                    Process file
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Row -->

      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>EMPLOYEE ID</th>
                        <th>DATE</th>
                        <th>TIME</th>
                        <th>STATE</th>
                        <th>SOURCE</th>
                        <th>SESSON TYPE</th>
                        <th>LATITUDE</th>
                        <th>LONGITUDE</th>
                        <th>ADDRESS</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table
                        :isLoading="isLoading"
                        cols="2"
                      ></loading-table>
                      <tr
                        v-for="(crudattendance, at) in crudAttendance"
                        :key="`crudattendance${at}`"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ crudattendance.employee_id }}</td>
                        <td>{{ crudattendance.date }}</td>
                        <td>{{ crudattendance.time }}</td>
                        <td>{{ crudattendance.state }}</td>
                        <td>{{ crudattendance.source }}</td>
                        <td>{{ crudattendance.session_type }}</td>
                        <td>{{ crudattendance.latitude }}</td>
                        <td>{{ crudattendance.longitude }}</td>
                        <td>{{ crudattendance.address }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "uploadAttendance",
  data() {
    return {
      crudAttendance: [],
      message: "",
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true;
      let crudAttendance = await axios.get(`/crude_attendances`);
      this.crudAttendance = crudAttendance.data.data;
      // console.log(this.crudAttendance);
      this.count = crudAttendance.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async handleFileUpload() {
      this.isLoading = true;
      this.Attendance = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append("attendanceData", this.Attendance);
      await axios
        .post("upload_attendance", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.data) this.crudAttendance = response.data.data;
          this.isLoading = false;
          // alert("Uploaded Successfully");
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
      this.isLoading = false;
    },
    async processFile() {
      try {
        this.isLoading = true;
        await axios.get("process_attendance");
        alert("Processed Successfully");
        await axios.get("truncate_attendances");
        this.crudAttendance = [];
        this.isLoading = false;
      } catch (e) {
        console.log(e);
      }
    },
    async truncatePendingDocuments() {
      await axios.get("truncate_attendances");
      alert("Truncated Successfully");
      this.crudAttendance = [];
    },
    async deleteDocument($id) {
      var r = confirm("Are you sure you want to delete the document!");
      if (r == true) {
        await axios.delete(`crude_attendance/${$id}`);
        this.crudAttendance = this.crudAttendance.filter((d) => d.id != $id);
      }
    },
  },
};
</script>
